import { CREATE_ROUGH_FABRIC_COSTING_DETAIL_FAILURE, CREATE_ROUGH_FABRIC_COSTING_DETAIL_REQUEST, CREATE_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS, CREATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE, CREATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST, CREATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS, CREATE_USERFORM_ROUGH_FABRIC_COSTING, CREATE_USERFORM_ROUGH_FABRIC_COSTING_DETAIL, DELETE_ROUGH_FABRIC_COSTING_HEADER_FAILURE, DELETE_ROUGH_FABRIC_COSTING_HEADER_REQUEST, FETCH_ROUGH_FABRIC_COSTING_DETAIL_FAILURE, FETCH_ROUGH_FABRIC_COSTING_DETAIL_REQUEST, FETCH_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS, FETCH_ROUGH_FABRIC_COSTING_HEADER_FAILURE, FETCH_ROUGH_FABRIC_COSTING_HEADER_REQUEST, FETCH_ROUGH_FABRIC_COSTING_HEADER_SUCCESS, FETCH_ROUGH_FABRIC_COSTING_INVOICE_FAILURE, FETCH_ROUGH_FABRIC_COSTING_INVOICE_REQUEST, FETCH_ROUGH_FABRIC_COSTING_INVOICE_SUCCESS, FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_FAILURE, FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_REQUEST, FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_SUCCESS, NAVIGATE_ROUGH_FABRIC_COSTING, NAVIGATE_ROUGH_FABRIC_COSTING_DETAIL, ROUGH_FABRIC_COSTING_DETAIL_USERFORM_RESET, ROUGH_FABRIC_COSTING_USERFORM_RESET } from "./roughFabricCosting.actionsType";




export const ROUGH_FABRIC_COSTING = 'roughFabricCosting';

let initialState = {
    loading: false,
    userform: {
        fldStyleNo: '',
        fldGSM: '',
        fldLeadTime: 0,
        fldYarnTknDt: new Date(),
        fldFabricInDt: new Date(),
        fldProcessLoss: 0

    },
    fabricCostinguserform: {
        fldIsYarnFabricCount: false
    },
    detailsId: '',
    activeKey: 1,
    roughFabricCostingHeader: [],
    fabricCostingDetailData: [],
    isRoughFabricCosting: false,
    fabricRoughCostingSelectedValue: '',
    fabricRoughCostingInvoiceData: []
}

export let roughFabricCosting = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case CREATE_ROUGH_FABRIC_COSTING_HEADER_REQUEST:
        case FETCH_ROUGH_FABRIC_COSTING_HEADER_REQUEST:
        case FETCH_ROUGH_FABRIC_COSTING_DETAIL_REQUEST:
        case CREATE_ROUGH_FABRIC_COSTING_DETAIL_REQUEST:
        case FETCH_ROUGH_FABRIC_COSTING_INVOICE_REQUEST:
        case DELETE_ROUGH_FABRIC_COSTING_HEADER_REQUEST:
        case FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CREATE_ROUGH_FABRIC_COSTING_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                detailsId: updatePayload
            };
        case FETCH_ROUGH_FABRIC_COSTING_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                roughFabricCostingHeader: updatePayload
            };
        case FETCH_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricCostingDetailData: updatePayload
            };
        case CREATE_ROUGH_FABRIC_COSTING_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case FETCH_ROUGH_FABRIC_COSTING_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricRoughCostingInvoiceData: [updatePayload]
            };
        case CREATE_USERFORM_ROUGH_FABRIC_COSTING:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },

            };
        case CREATE_USERFORM_ROUGH_FABRIC_COSTING_DETAIL:
            return {
                ...state,
                loading: false,
                fabricCostinguserform: {
                    ...state.fabricCostinguserform,
                    [payload.key]: payload.value
                },

            };
        case FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,

                }
            };
        case CREATE_ROUGH_FABRIC_COSTING_HEADER_FAILURE:
        case FETCH_ROUGH_FABRIC_COSTING_HEADER_FAILURE:
        case FETCH_ROUGH_FABRIC_COSTING_DETAIL_FAILURE:
        case CREATE_ROUGH_FABRIC_COSTING_DETAIL_FAILURE:
        case FETCH_ROUGH_FABRIC_COSTING_INVOICE_FAILURE:
        case DELETE_ROUGH_FABRIC_COSTING_HEADER_FAILURE:
        case FETCH_SINGLE_ROUGH_FABRIC_COSTING_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case ROUGH_FABRIC_COSTING_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                userform: {
                    fldStyleNo: '',
                    fldGSM: '',
                    fldLeadTime: 0,
                    fldYarnTknDt: new Date(),
                    fldFabricInDt: new Date(),
                    fldProcessLoss: 0
                },
            };
        case ROUGH_FABRIC_COSTING_DETAIL_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                fabricCostinguserform: {
                    fldProcessName: '',
                    fldSupplierName: '',
                    fldDescription: '',
                    fldEstimateQuantity: 0,
                    fldEstimateRate: 0,
                    fldEstimateValue: 0,
                    fldIsYarnFabricCount: false
                },
            };
        case NAVIGATE_ROUGH_FABRIC_COSTING_DETAIL:
            return {
                ...state,
                isRoughFabricCosting: true,
                loading: false,
                roughFBCostingSelectedValue: updatePayload.roughFBCostingSelectedValue
            };
        case NAVIGATE_ROUGH_FABRIC_COSTING:
            return {
                ...state,
                isRoughFabricCosting: false
            };
        default:
            return state;
    }
}